/**
 * Predicate that decides which React-Query entries `approveReview` must
 * invalidate after a successful POST.
 *
 * Approving an entity can touch the entity row, its facts, doc relations,
 * every interaction it appears on, and backreference source facts on other
 * entities — data scattered across queries under several top-level keys.
 * Different data hooks use different keys: "rms" for entity/search/schema/
 * contacts, "interactions" for interaction detail, "rmsEntityInteractions"
 * for the lazy interactions list on the entity dashboard.
 *
 * If a new RMS surface ever shows stale staging/badge state after Approve
 * All, the most likely cause is a new top-level key that needs to be added
 * to this set. Update both the constant and the test together.
 */
export const APPROVE_AFFECTED_QUERY_KEYS: ReadonlySet<string> = new Set([
  "rms",
  "interactions",
  "rmsEntityInteractions",
]);

export const isApproveAffectedQuery = (query: {
  queryKey: readonly unknown[];
}): boolean =>
  typeof query.queryKey[0] === "string" &&
  APPROVE_AFFECTED_QUERY_KEYS.has(query.queryKey[0] as string);
